import { createContext } from 'react'
import type { Lang } from '@/types/lang'

/** Язык интерфейса для `useMessages`; `null` — вне `LanguageProvider` (берётся `getUiLang`). */
export const UiLangContext = createContext<Lang | null>(null)
